import { Identifier } from "../../id";
export class OrderCouponCode extends Identifier {
    constructor(code) {
        super("OrderCouponCode", code);
    }
}
